<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRastreabilidadeGestaoBungeEmpresa',
    componentOptions: {
        title: 'RastreabilidadeGestaoEmpresa',
        actions: [
            [
                {
                    name: 'Contratos de originação',
                    showView: false,
                    action: 'abrir',
                    route: 'RastreabilidadeEmpresa',
                    nameTranslationKey:
                        'mensagens.menuLateral.contratosOriginacao'
                }
            ]
        ]
    },

    methods: {
        abrir() {
            if (this.$route.name !== 'RastreabilidadeEmpresa') {
                this.$router.push({ name: 'RastreabilidadeEmpresa' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
